<nph-layout-topbar-language [languages]="languages" [(selectedLanguage)]="selectedLanguage"
    (selectedLanguageChange)="afterChangeLanguage($event)" />
<!-- <nph-layout-topbar-user-apps [apps]="apps"/> -->